import { useState } from 'react';
import { LiaExchangeAltSolid } from 'react-icons/lia';
import { NATIVE_ADDRESS, ZERO_ADDRESS } from '@shared/utils/config/networks';
import classNames from '@/lib/misc/classNames';
import SwapSettings from '../mobile/SwapSettings';
import OrderTypeModal from '../mobile/OrderTypeModal';
import SelectedFromAssetsDetails from '../swap-home/SelectedFromAssetsDetails';
import AssetSelectionMobile from '../swap-home/AssetSelectionMobile';
import SelectPercentage from './SelectPercentage';
import SelectUsdAmount from './SelectUsdAmount';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useSession } from '@/contexts/LitSessionProvider';
import { useSwap } from '@/contexts/SwapProvider';
export default function SelectionScreen({
  showAmount,
  setShowAmount,
  isSwitched,
  setIsSwitched,
  setPercentage
}) {
  const {
    PKP
  } = useSession();
  const {
    setSelectFromAsset,
    setSelectToAsset,
    fromAssets,
    setFromAssets,
    toAssets,
    setToAssets
  } = useSwap();
  const {
    data: assetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress]
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const [isOrderModalOpen, setOrderModalOpen] = useState(false);
  const toAssetsIsInFromAsset = () => {
    if (toAssets.length) {
      const toAssetAddress = toAssets[0].contract_address;
      const hasInBalance = assetData?.balances?.some(asset => {
        if (asset.contract_address === toAssetAddress && asset.network === toAssets[0].network) {
          return true;
        }
        if (toAssetAddress === ZERO_ADDRESS && asset.contract_address?.toLowerCase() == NATIVE_ADDRESS?.toLowerCase() && asset.network === toAssets[0].network) {
          return true;
        }
        return false;
      });
      if (hasInBalance) {
        return true;
      }
      return false;
    }
  };
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  function handleSwitchAssets() {
    console.log('userBalances', assetData.balances);
    if (!fromAssets || !Array.isArray(fromAssets)) return;
    if (!toAssets || !Array.isArray(toAssets)) setToAssets([]);
    const userBalances = assetData.balances;
    console.log('userBalances', userBalances);
    let amountToUseStr = '0';
    let amountToUse = 0;
    let contract_ticker_symbol = null;
    const fromAssetInBalance = userBalances.find(balance => balance.contract_address === toAssets[0].contract_address && balance.network === toAssets[0].network);
    console.log('fromAssetInBalance', fromAssetInBalance);
    if (toAssets.length && toAssets[0]) {
      console.log('toAssets', toAssets[0]);
      console.log('fronm assets', fromAssets[0]);
      userBalances.map((token: any) => {
        if (token.contract_address === toAssets[0].contract_address && token.network === toAssets[0].network) {
          amountToUseStr = token.usd_value?.toString();
          amountToUse = token.usd_value;
          contract_ticker_symbol = token.contract_ticker_symbol;
        }
      });
      console.log('amounts--->', {
        amountToUseStr,
        amountToUse
      });
      setShowAmount('0');
      setFromAssets([{
        ...fromAssetInBalance,
        amountToUseStr: '0',
        amountToUse: 0,
        usd_value: amountToUse,
        contract_ticker_symbol: contract_ticker_symbol
      }]);
    } else {
      setFromAssets([]);
    }
    if (fromAssets.length && fromAssets[0]) {
      setToAssets([fromAssets[0]]);
    } else {
      setToAssets([]);
    }
  }
  return <>
      <div className={`w-full p-1`}>
        <div className='flex w-full items-center flex-col justify-center gap-2'>
          <div className='flex items-center w-full'>
            <SelectedFromAssetsDetails totalAmount={showAmount} fromAssets={fromAssets} isSwitched={isSwitched} setIsSwitched={setIsSwitched} toggleOrderModal={() => setOrderModalOpen(!isOrderModalOpen)} data-sentry-element="SelectedFromAssetsDetails" data-sentry-source-file="SelectionScreen.tsx" />
            <OrderTypeModal isModalOpen={isOrderModalOpen} toggleModal={() => setOrderModalOpen(!isOrderModalOpen)} data-sentry-element="OrderTypeModal" data-sentry-source-file="SelectionScreen.tsx" />
            <SwapSettings isModalOpen={isModalOpen} toggleModal={toggleModal} data-sentry-element="SwapSettings" data-sentry-source-file="SelectionScreen.tsx" />
          </div>
        </div>
      </div>

      {!fromAssets[0] ? <SelectUsdAmount /> : <SelectPercentage setPercentage={setPercentage} toggleModal={toggleModal} />}

      <div className={classNames('relative w-full flex justify-center mt-4', {
      'flex-col items-center': false
    })}>
        <AssetSelectionMobile mode='From' setSelectFromAsset={setSelectFromAsset} setSelectToAsset={setSelectToAsset} desktop={false} assets={fromAssets} data-sentry-element="AssetSelectionMobile" data-sentry-source-file="SelectionScreen.tsx" />
        {toAssetsIsInFromAsset() && <div onClick={() => handleSwitchAssets()} className='z-[999] absolute cursor-pointer top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[28px] h-[28px] bg-black text-genius-cream flex items-center justify-center rounded-md'>
            <LiaExchangeAltSolid className='' />
          </div>}

        <AssetSelectionMobile mode='To' setSelectFromAsset={setSelectFromAsset} setSelectToAsset={setSelectToAsset} desktop={false} assets={toAssets} data-sentry-element="AssetSelectionMobile" data-sentry-source-file="SelectionScreen.tsx" />
      </div>
    </>;
}